// extracted by mini-css-extract-plugin
export default {"table_area":"ClientManagement_table_area__VYz+M"};